import React from 'react';
import '../styles/Footer.css';
import { FaMapMarkerAlt, FaWhatsapp, FaLinkedin } from 'react-icons/fa';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Left side: Icons */}
        <div className="footer-icons">
          <a
            href="https://wa.me/14376043134"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-icon"
            aria-label="WhatsApp"
          >
            <FaWhatsapp />
          </a>
          <a
            href="https://www.linkedin.com/company/bularis-tech"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-icon"
            aria-label="LinkedIn"
          >
            <FaLinkedin />
          </a>
        </div>

        {/* Right side: Address */}
        <div className="footer-location">
          <FaMapMarkerAlt />
          <span>16 Alphonse Crescent, Mississauga, Ontario L5M 1A5, CA</span>
        </div>
      </div>

      {/* Bottom Rights */}
      <div className="footer-rights">
        © {new Date().getFullYear()} Bularis Tech. All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;
